import type { Moment } from 'moment'

import asyncAction from 'modules/core/lib/asyncAction'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { Model } from 'modules/core/lib/mobx-rest'

interface UpdateInfo {
  from: Moment
  to: Moment
  leave_type_id: number
  half_day: string | null | undefined
  start_time: string | null | undefined
  hours_amount_in_cents: number | null | undefined
  accrues?: boolean
}

interface ILabourUnit {
  [key: string]: any
}

class LabourUnit extends Model<ILabourUnit> {
  // FIXME: consider moving this to the view and using the static fetch
  updateInfo(data: UpdateInfo) {
    const { from, to } = data
    const invalidDate = !from.isValid() || !to.isValid()

    if (invalidDate) {
      return Promise.resolve({
        success: false,
        value: null,
      })
    }

    const employeeId = this.attributes.employee_id

    return asyncAction(
      () =>
        this.fetch({
          data: {
            ...data,
            from: dateToString(from, 'backend'),
            to: dateToString(to, 'backend'),
          },
          path: `/labour_days/${employeeId}`,
        }),
      {
        successFlash: false,
        errorMessage: i18n.t('errors.generic_requesting'),
      }
    )
  }
}

export default LabourUnit
